import api from "../base-url";

async function createVersion(
  appID: string,
  versionNumber: string,
  changelogs: string,
  released_at: string,
  platform: string,
  bundleId: string,
  uploadFile: File
) {

  const formData = new FormData();
  formData.append("appId", appID);
  formData.append("versionNumber", versionNumber);
  formData.append("changelogs", changelogs);
  formData.append("released_at", released_at);
  formData.append("platform", platform);
  formData.append("bundleId", bundleId);
  formData.append("uploadFile", uploadFile);

  let res = await api.post(`versions`, formData);

  return res;
}

export default createVersion;
